import { render, staticRenderFns } from "./recommendTable.vue?vue&type=template&id=006e1517"
import script from "./recommendTable.vue?vue&type=script&lang=ts"
export * from "./recommendTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports